<template>
  <div class="card height-100" id="infoCommande">
    <header class="header-card">
      <p>
        {{ $t('detailTiers.titres.commande')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns">
        <div class="column is-12">
          <p>
           <span class="has-text-default is-italic">
                      {{$t('detailTiers.commande.nombreMoisPreavis')}}
           </span>
          <span class="has-text-default has-text-weight-semibold">
                      {{ tiers.nombreMoisPreavis }}
          </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tiers: {
      type: Object,
      required: true,
    },
  },
};
</script>
